<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Pitch Name" prop="pitchName" >
        <a-input v-model="form.pitchName" placeholder="Please enter pitch name" />
      </a-form-model-item>
      <a-form-model-item label="Rating" prop="rating" >
        <a-input-number
          v-model="form.rating"
          :min="0"
          :max="5"
          :step="0.1"
          :precision="1"
          placeholder="0 ~ 5"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="Longitude" prop="longitude" >
        <a-input v-model="form.longitude" placeholder="Please enter longitude" />
      </a-form-model-item>
      <a-form-model-item label="Latitude" prop="latitude" >
        <a-input v-model="form.latitude" placeholder="Please enter latitude" />
      </a-form-model-item>
      <a-form-model-item label="Introduction" prop="introduction" >
        <a-input v-model="form.introduction" placeholder="Please enter content" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="Address" prop="address" >
        <a-input v-model="form.address" placeholder="Please enter address" />
      </a-form-model-item>
      <a-form-model-item label="Business Start Time" prop="startTime" >
        <a-time-picker
          v-model="startTimeMoment"
          format="HH:mm"
          :minute-step="1"
          placeholder="Select start time"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="Business End Time" prop="endTime" >
        <a-time-picker
          v-model="endTimeMoment"
          format="HH:mm"
          :minute-step="1"
          placeholder="Select end time"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="Infrastructure" prop="infrastructureIds" >
        <a-select
          v-model="infrastructureIdList"
          mode="multiple"
          placeholder="Please select infrastructure"
          :loading="infrastructureLoading"
          allow-clear
          style="width: 100%"
          option-filter-prop="children"
        >
          <a-select-option
            v-for="item in infrastructureOptions"
            :key="item.id"
            :value="String(item.id)"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Tags" prop="tagIds" >
        <a-select
          v-model="tagIdList"
          mode="multiple"
          placeholder="Please select tags"
          :loading="tagLoading"
          allow-clear
          style="width: 100%"
          option-filter-prop="children"
        >
          <a-select-option
            v-for="item in tagOptions"
            :key="item.id"
            :value="String(item.id)"
          >
            {{ item.tagTitle }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Officially Certified" prop="isAuth" >
        <a-select
          v-model="form.isAuth"
          placeholder="Please select"
          allow-clear
          style="width: 100%"
        >
          <a-select-option :value="0">No</a-select-option>
          <a-select-option :value="1">Yes</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Pitch Banner Images" prop="logoUrls" >
        <file-upload
          :value="form.logoUrls || ''"
          type="image"
          :count="9"
          field-name="logoUrls"
          @change="handleLogoUrlsChange"
        />
      </a-form-model-item>
      <!-- <a-form-model-item label="Remark" prop="remark" >
        <a-input v-model="form.remark" placeholder="Please enter content" type="textarea" allow-clear />
      </a-form-model-item> -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import { getPitch, addPitch, updatePitch } from '@/api/golf/pitch'
import { listInfrastructure } from '@/api/golf/infrastructure'
import { listTag } from '@/api/golf/tag'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      infrastructureLoading: false,
      tagLoading: false,
      infrastructureOptions: [],
      tagOptions: [],
      infrastructureIdList: [],
      tagIdList: [],
      startTimeMoment: null,
      endTimeMoment: null,
      // Form fields
      form: {
        id: null,

        pitchName: null,

        rating: null,

        longitude: null,

        latitude: null,

        introduction: null,

        address: null,

        startTime: null,

        endTime: null,

        infrastructureIds: null,

        tagIds: null,

        isAuth: null,

        logoUrls: null,

        createTime: null,

        remark: null

      },
      // 1 add, 2 edit
      formType: 1,
      open: false,
      rules: {
        rating: [
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback()
                return
              }
              const n = Number(value)
              if (Number.isNaN(n) || n < 0 || n > 5) {
                callback(new Error('Rating must be between 0 and 5'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.loadSelectOptions()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    loadSelectOptions () {
      this.infrastructureLoading = true
      listInfrastructure({})
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : []
          this.infrastructureOptions = list
        })
        .finally(() => {
          this.infrastructureLoading = false
        })
      this.tagLoading = true
      listTag({})
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : []
          this.tagOptions = list
        })
        .finally(() => {
          this.tagLoading = false
        })
    },
    parseTimeToMoment (v) {
      if (v === null || v === undefined || v === '') return null
      const m = moment(v, ['HH:mm', 'H:mm'], true)
      return m.isValid() ? m : null
    },
    syncFormToUi () {
      const inf = this.form.infrastructureIds
      this.infrastructureIdList = inf
        ? String(inf).split(',').map(s => s.trim()).filter(Boolean)
        : []
      const tags = this.form.tagIds
      this.tagIdList = tags
        ? String(tags).split(',').map(s => s.trim()).filter(Boolean)
        : []
      this.startTimeMoment = this.parseTimeToMoment(this.form.startTime)
      this.endTimeMoment = this.parseTimeToMoment(this.form.endTime)
      if (this.form.isAuth !== null && this.form.isAuth !== undefined) {
        this.form.isAuth = Number(this.form.isAuth)
      }
    },
    applySubmitFields () {
      this.form.infrastructureIds = this.infrastructureIdList.length
        ? this.infrastructureIdList.join(',')
        : null
      this.form.tagIds = this.tagIdList.length
        ? this.tagIdList.join(',')
        : null
      this.form.startTime = this.startTimeMoment
        ? this.startTimeMoment.format('HH:mm')
        : null
      this.form.endTime = this.endTimeMoment
        ? this.endTimeMoment.format('HH:mm')
        : null
    },
    handleLogoUrlsChange (payload) {
      if (typeof payload === 'string') {
        this.form.logoUrls = payload || null
      } else if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'logoUrls')) {
        this.form.logoUrls = payload.logoUrls || null
      }
    },
    onClose () {
      this.open = false
    },
    // Cancel button
    cancel () {
      this.open = false
      this.reset()
    },
    // Reset form
    reset () {
      this.formType = 1
      this.infrastructureIdList = []
      this.tagIdList = []
      this.startTimeMoment = null
      this.endTimeMoment = null
      this.form = {
        id: null,
        pitchName: null,
        rating: null,
        longitude: null,
        latitude: null,
        introduction: null,
        address: null,
        startTime: null,
        endTime: null,
        infrastructureIds: null,
        tagIds: null,
        isAuth: null,
        logoUrls: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** Add action */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    /** Edit action */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPitch({ id: id }).then(response => {
        this.form = response.data
        this.syncFormToUi()
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    /** Submit */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.applySubmitFields()
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePitch(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPitch(this.form).then(response => {
              this.$message.success(
                'Added successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
